export enum PricingProgramStatus {
  active = 'pricingprogramsactivetab',
  executed = 'pricingprogramsexecutedtab',
  cancelled = 'pricingprogramscancelledtab',
}
